import { Auth } from "aws-amplify";
import { useStateMachine } from "little-state-machine";
import { useEffect } from "react";
import { updateLoggingOut } from "actions/updateLoggingOut";

const HandleLogoutComponent = () => {
  const { actions } = useStateMachine({
    updateLoggingOut
  });

  useEffect(() => {
    async function logout() {
      try {
        Auth.currentAuthenticatedUser().then(() => {
          Auth.signOut().then(() => {
            // window.location.href = "/";
          });
        });
      } catch (error) {
        // console.log("error signing out: ", error);
      }
    }

    actions.updateLoggingOut(true);

    logout();
  }, [actions]);

  return <></>;
};

export default HandleLogoutComponent;
